export const columns = [
  {
    key: 'name',
    label: 'Name',
    minWidth: 400,
    sortable: true,
  },
  {
    key: 'createdAt',
    label: 'Created at',
    sortable: true,
  },
];
